import { actionTypes } from 'BASE/store/types'
import CONSTANT from 'BASE/common/chat/chat.constant'
import UTIL from 'BASE/common/chat/chat.util'
import SETTING from 'BASE/common/chat/chat.setting'
import * as ApiProxy from 'BASE/common/util/util.apiProxy'
import { Html } from 'BASE/common/util/util';

export default {
    props: {
        prop_message: Object,
        prop_room_member_container: Object,
    },
    data: function () {
        return {
            _isMySelf: false,
            _isCustomerService: false,
            _isSystem: false,
            isGroupRoom: this.prop_room_member_container.room.type === CONSTANT.roomType.DESCENDANT_GROUP,
            isCommittingCustomerService: false,
        };
    },
    methods: {
        commitCustomerServiceQuestionType: async function () {
            if (this.isCommittingCustomerService) return;
            
            this.isCommittingCustomerService = true;
            await this.$store.dispatch(actionTypes.CHAT_ADD_CUSTOMER_SERVICE_WAITING, {
                connectionParams: {
                    waitConnected: true,
                    loading: this.$loading,
                },
            });
            this.isCommittingCustomerService = false;
        },
        imageLoaded: function () {
            this.$emit("updateScrollbar");
        },
    },
    computed: {
        isMyself: function () {
            this._isMySelf = this.prop_message.userId === this.$store.state.chat.userId;
            return this._isMySelf;
        },
        isCustomerService: function () {
            this._isCustomerService =
                this.prop_room_member_container.room.type === CONSTANT.roomType.CUSTOMER_SERVICE
                && !!this.prop_message.userId;
            return this._isCustomerService;
        },
        isSystem: function () {
            this._isSystem = this.prop_room_member_container.room.type === CONSTANT.roomType.SYSTEM;
            return this._isSystem;
        },
        isOthers: function () {
            return !this._isMySelf && !this._isCustomerService && !this._isSystem;
        },
        isText: function () {
            return this.prop_message.type === CONSTANT.messageType.TEXT;
        },
        isImage: function () {
            return this.prop_message.type === CONSTANT.messageType.IMAGE;
        },
        isEmotion: function () {
            return this.prop_message.type === CONSTANT.messageType.EMOTION;
        },
        isBet: function () {
            return this.prop_message.type === CONSTANT.messageType.BET;
        },
        isInfo: function () {
            return this.prop_message.type === CONSTANT.messageType.INFO
                || this.prop_message.type === CONSTANT.messageType.CUSTOMER_SERVICE_WAITING_INFO;
        },
        isWarning: function () {
            return this.prop_message.type === CONSTANT.messageType.WARNING;
        },
        isCustomerServiceQuestionList: function () {
            return this.prop_message.type === CONSTANT.messageType.CUSTOMER_SERVICE_QUESTION_LIST;
        },
        isRedPackActivityReceive: function () {
            return this.prop_message.type === CONSTANT.messageType.RED_PACK_ACTIVITY_RECEIVE;
        },
        isBetPlan: function () {
            return this.prop_message.type === CONSTANT.messageType.BET_PLAN;
        },
        name: function () {
            return this.prop_message.name;
        },
        content: function () {
            if (this.prop_message.type === CONSTANT.messageType.IMAGE) {
                return ApiProxy.urlCombine(this.prop_message.content);
            }

            if (this.prop_message.type === CONSTANT.messageType.TEXT) {
                let inputText = Html.HtmlEncode(this.prop_message.content);  //轉換避免script攻擊
                return UTIL.linkify(inputText);
            }

            return this.prop_message.content;
        },
        contentPreview: function () {
            return ApiProxy.urlCombine(UTIL.getPreviewImageUrl(this.prop_message.content));
        },
        timestamp: function () {
            return UTIL.formatDate(this.prop_message.timestamp, "YYYY/MM/DD HH:mm:ss");
        },
        userLevel: function () {
            let level = this.prop_message.userLevel;
            if (level) {
                return SETTING.messages.MESSAGE_USER_LEVEL(level);
            } else {
                return undefined;
            }
        },
        headImage: function () {
            return this.prop_message.headImage ? ApiProxy.urlCombine(this.prop_message.headImage) : '';
        },
    }
};
